<template>
    <ToolingQuote></ToolingQuote>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const ToolingQuote = defineAsyncComponent(() =>
    import("../../components/Purchasing/ToolingQuote/ToolingQuote.vue")
);

export default {
    name: "ToolingQuotePage",
    components: { ToolingQuote, AuthLayout },
};
</script>
